import React, { useState } from 'react';
import api from '../../services/api';

import {
    Modal,
    Button,
    Form,
    Dropdown
} from 'react-bootstrap';
import AlertErro from '../alertErro';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
library.add(fas);

export default function ModalAlteraSenha(props) {
    const [show, setShow] = useState(false);
    const [senha, setSenha] = useState('');
    const [senhaRepetida, setSenhaRepetida] = useState('');
    const [erro, setErro] = useState('');

    const handleShow = () => setShow(true);
    const handleClose = () => {
        erro && setErro('')
        senha && setSenha('');
        senhaRepetida && setSenhaRepetida('');

        setShow(false)
    };


    function alterarSenha() {
        erro && setErro('');

        if (senha === '' || senhaRepetida === '')
        {
            setErro('Todos os campos devem ser preenchidos.');
        }
        else if (senha !== senhaRepetida)
        {
            setErro('As senhas informadas devem ser iguais.');
        }
        else
        {
            const json = JSON.stringify({
                usuario: sessionStorage.getItem('RC_USR_PORTAL'),
                senha: senha,
                alias: window.alias_RC
            })

            const config = {
                ALTER: [
                    { TOKEN: btoa(json) }
                ]
            }

            api.post('/AlteraSenhaGlobal', config)
                .then(res => {
                    if (res.data.CODIGO === '0')
                    {
                        sessionStorage.setItem('RC_ALTPSW', 'F');
                        handleClose();
                    }
                    else
                    {
                        setErro(res.data.DESCRICAO)
                    }
                })
                .catch(err => setErro(err.toString()));
        }
    }

    const buttonStyle = {
        hide: {
            visibility: 'hidden'
        },
    }

    return (
        <>
            <Dropdown.Item id='btnAlteraSenha' onClick={() => handleShow()} style={props.hideButton && buttonStyle.hide}>
                <FontAwesomeIcon icon="key" className="mr-2" />
                Alterar Senha
            </Dropdown.Item>

            <Modal show={show} backdrop='static' onHide={() => handleClose()} keyboard={false} centered>
                <Modal.Header>
                    <Modal.Title>Alteração de Senha</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {props.hideButton &&
                        <p>
                            Será necessário alterar sua senha neste acesso, por gentileza insira
                            sua nova senha nos campos abaixo.
                        </p>
                    }

                    <div className='form'>
                        <Form.Group controlId="senha">
                            <Form.Label>Nova Senha</Form.Label>
                            <Form.Control type="password" value={senha} onChange={e => setSenha(e.target.value)} />
                        </Form.Group>

                        <Form.Group controlId="senhaRepetida">
                            <Form.Label>Repita a Nova Senha</Form.Label>
                            <Form.Control type="password" value={senhaRepetida} onChange={e => setSenhaRepetida(e.target.value)} />
                        </Form.Group>

                        {erro && <AlertErro mensagem={erro} />}
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    {props.showButton &&
                        <Button variant="light" onClick={() => handleClose()}>
                            Cancelar
                        </Button>
                    }
                    <Button variant="primary" onClick={() => alterarSenha()}>
                        Alterar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}